import { paths } from "~constants/referenceNames";
import getUrlParam from "~libs/urlParams";
import isNullOrEmpty from "~libs/isNullOrEmpty";
import moment from "moment";

export interface UrlParam {
  name: string;
  nameUrl: string;
  action: (value: any) => any;
  isDate?: boolean;
}

interface GetUrlWithParametersArgs {
  params: UrlParam[];
  currentState: Record<string, any>;
  index: string;
}

interface UpdateUrlParametersArgs {
  params: UrlParam[];
  location: any;
  dispatch: (action: any) => void;
  setPage: (page: number) => any;
}

export const getUrlWithParameters = ({
  params,
  currentState,
  index,
}: GetUrlWithParametersArgs): string => {
  const page = currentState.page;
  const take = currentState.take;

  let parameters = "";

  params.map((parameter) => {
    const value = currentState[parameter.name];

    if (value) {
      const valueParsed = parameter.isDate
        ? moment(value).local().format("L")
        : value;

      parameters = isNullOrEmpty(parameters)
        ? `${parameter.nameUrl}=${valueParsed}`
        : parameters + `&${parameter.nameUrl}=${valueParsed}`;
    }
    return true;
  });

  parameters = parameters + `&Skip=${page * take}`;
  let url = paths[index as keyof typeof paths] + "?" + parameters;

  return url;
};

export const updateUrlParameters = ({
  params,
  location,
  dispatch,
  setPage,
}: UpdateUrlParametersArgs) => {
  params.map((parameter) => {
    const value = getUrlParam(location, parameter.nameUrl);

    if (value) {
      if (parameter.isDate) {
        // Una fecha malformada en la URL produce un `Invalid Date`, que es truthy
        // y sobrevive a los chequeos aguas abajo hasta romper en `toISOString()`.
        // Se ignora el parámetro, igual que cuando no viene.
        const parsed = moment(value, "DD/MM/YYYY");
        if (parsed.isValid()) dispatch(parameter.action(parsed.toDate()));
      } else {
        dispatch(parameter.action(value));
      }
    }

    return value;
  });

  const takeParameter = getUrlParam(location, "Take");
  const skipParameter = getUrlParam(location, "Skip");
  if (skipParameter) {
    const page =
      takeParameter !== 0 ? Math.floor(skipParameter / takeParameter) : 0;
    dispatch(setPage(page));
  }
};
